import React from 'react'

import { FaSpotify, FaMusic, FaYoutube } from 'react-icons/fa'

import Layout from '../components/layout'

const Listen = () => {

    const tracks = [
        {
            embedSrc: "https://open.spotify.com/embed/album/2XSWk9WtIOuHDfNAoL8vBb?utm_source=generator",
            title: "New Black Elite Album",
            umLink: "https://unitedmasters.com/m/6197cc0999d5e65549652ba3"
        },
        {
            embedSrc: "https://open.spotify.com/embed/track/50Gb81HMRAZ6zV4WZbMeCc?utm_source=generator",
            title: "Black Gold",
            umLink: "https://unitedmasters.com/m/6172e7c26b55ac14f0c1b464"
        },

        {
            embedSrc: "https://open.spotify.com/embed/track/5EScAS5xVrToPaOsG02tlK?utm_source=generator",
            title: "Amina's Walls",
            umLink: "https://unitedmasters.com/m/6176f5b16b55ac5c8e76433c"
        },

        {
            embedSrc: "https://open.spotify.com/embed/track/2mNXeRH6AUODy5PBCfNKMV?utm_source=generator",
            title: "Abacha Loot",
            umLink: "https://unitedmasters.com/m/613a2b5d6ac7de384a67b732"
        },
    ]

    return (
        <Layout showHeader={true}>
            <section className="section">

                {
                    tracks.map(({ embedSrc, title, umLink }, index) => 
                        <div className="column is-half is-offset-one-quarter">
                            <div className="my-3">
                                <h2 className="is-size-2 mb-4 has-text-centered-mobile">{title}</h2>

                                <iframe src={embedSrc} 
                                width="100%" height="380" 
                                title={`${title} single from Isah The Prince`}
                                frameBorder="0" 
                                allowfullscreen="" 
                                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture">
                                </iframe>

                                <div className="listen-icons my-4">
                                    <div className="is-size-3" style={{display: 'inline-block'}}>
                                        <a href={umLink} target="_blank" rel="noopener noreferrer">
                                            <span><FaMusic className="hover mr-3" /><FaSpotify className="hover mr-3" /><FaYoutube className="hover" /></span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </section>
        </Layout>
    )
}

export default Listen
